/**
 * The possible states of an analytics event that has been completed. Generally these events
 * are coupled with a time/duration (e.g. see CompletedTimedEventMetadata)
 */
export enum AnalyticsEventOutcome {
  SUCCESS = 'success',
  FAILURE = 'failure',
}
